import { render, staticRenderFns } from "./register.vue?vue&type=template&id=48c2e2ce&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.css?vue&type=style&index=0&id=48c2e2ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c2e2ce",
  null
  
)

export default component.exports